const STATIC_SEGMENTS_BY_NAMED_ID_ROUTE = new Map<string, Set<string>>([
  ['collections', new Set()],
  ['events', new Set()],
  ['flag-applied', new Set()],
  ['flags', new Set(['resolver-test', 'segments', 'tools'])],
  ['recordings', new Set(['explorer', 'insights', 'settings'])],
  ['segments', new Set()],
]);

export const parameterizeRoute = (pathname: string): string => {
  if (pathname.includes('%') || pathname.includes('//')) {
    return '/:junk';
  }

  const segments = pathname.split('/');

  return segments
    .map((segment, index) => {
      if (/^[a-z][a-z0-9]{19}$/.test(segment)) {
        return ':id';
      }
      if (/^[0-9a-f]{32}$/.test(segment)) {
        return ':id';
      }
      if (/[0-9a-f]{20}/.test(segment)) {
        return ':id';
      }

      const parentSegment = segments[index - 1];
      const staticRouteSegments = parentSegment
        ? STATIC_SEGMENTS_BY_NAMED_ID_ROUTE.get(parentSegment)
        : undefined;
      if (staticRouteSegments && !staticRouteSegments.has(segment)) {
        return ':id';
      }

      return segment;
    })
    .join('/');
};
